import {Option} from '@tager/web-core';

import {TFunction} from "@/typings/common";

export enum SORT_TYPE {
  Popular = 'POPULAR',
  New = 'NEW',
  PriceHigh = 'PRICE_HIGH',
  PriceLow = 'PRICE_LOW',
}

export const getOptions = (t: TFunction): Option[] => {
  return [
    {
      label: t('sort.popular'),
      value: SORT_TYPE.Popular,
    },
    {
      label: t('sort.new'),
      value: SORT_TYPE.New,
    },
    {
      label: t('sort.expensive'),
      value: SORT_TYPE.PriceHigh,
    },
    {
      label: t('sort.cheap'),
      value: SORT_TYPE.PriceLow,
    },
  ]
}
